import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../../hooks/useScale';
import { useColors } from '../../../hooks/useColors';
import theme from '../../../common/theme';

const ModifierStylePreviewModalStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        background: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.colors.modalBg,
        },
        card: {
          width: scale(420),
          maxWidth: '92%',
          backgroundColor: colors.popupBg,
          borderRadius: theme.radius.l,
          padding: scale(24),
          rowGap: scale(12),
        },
        header: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        },
        title: {
          color: colors.text,
          fontSize: scale(18),
          fontFamily: theme.fonts.semibold,
        },
        closeButton: {
          width: scale(32),
          height: scale(32),
          borderRadius: theme.radius.s,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.inputBackground,
        },
        caption: {
          color: colors.textLight,
          fontSize: scale(13),
          lineHeight: scale(18),
          fontFamily: theme.fonts.regular,
        },
        // The frame stands in for the KDS grid behind a docket. It uses
        // `background` (not `elevation0`) because in dark mode `elevation0`
        // equals the modal card's `popupBg`, which made the frame vanish into
        // the card. `background` reads darker than the card in both themes.
        frame: {
          backgroundColor: colors.background,
          borderRadius: theme.radius.m,
          padding: scale(12),
        },
        docket: {
          backgroundColor: colors.elevation1,
          borderRadius: theme.radius.m,
          overflow: 'hidden',
          paddingHorizontal: scale(6),
          paddingBottom: scale(8),
        },
        docketHeader: {
          backgroundColor: theme.colors.primary,
        },
        itemRow: {
          alignItems: 'center',
        },
        qty: {
          alignItems: 'center',
          justifyContent: 'center',
        },
        modifierText: {
          opacity: 1,
        },
        modifierItalic: {
          fontStyle: 'italic',
        },
      }),
    [colors, scale],
  );
};

export default ModifierStylePreviewModalStyles;
